import { Component, EventEmitter, Input, OnChanges, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { BankBilletData } from '../../model/bank-billet-data';
import { Contract } from '../../model/contract';
import { CreditCardData } from '../../model/credit-card-data';
import { SnackBarService } from '../../services/snack-bar.service';
import { PixData } from '../../model/pix-data';
import { SelfAttendanceService } from '../../services/self-attendance.service';
import { pix2ndCopyErrors } from '../../constants/errors';
import { DtmService } from 'src/app/services/dtm.service';
import { Dtm, getDtm } from '../../enum/dtm';
import { environment } from 'src/environments/environment';
import { SessionStorageService } from '../../services/session-storage.service';

import moment from 'moment';
import { Invoice } from '../../model/invoice';

@Component({
    selector: 'pme-purchase-info',
    templateUrl: './purchase-info.component.html',
    styleUrls: ['./purchase-info.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class PurchaseInfoComponent implements OnInit, OnChanges {

  @Input() creditCardData: CreditCardData;
  @Input() bankBilletData: BankBilletData;
  @Input() contract: Contract;
  @Input() pixData: PixData;
  @Input() finalBalanceTrust: number;
  @Input() balanceExpirationDate: any;
  @Input() invoice: Invoice;
  nowDate: String;
  delayTest: number = 0;
  installment: number;
  expirationTime: number;
  timeExpired: boolean = false;
  isPixPaid: boolean = false;
  interval: any;
  submitting: boolean;
  errors: any;
  classificationIdentifier: string;
  classificationName: string;
  endDate: string;
  codeErrorIpt: string;
  detailErrorIpt: string;
  statusItp: string;
  messageErrorItp: string;
  @Output() onSuccessButtonClick: EventEmitter<any> = new EventEmitter<any>();

  constructor(
    private snackBarService: SnackBarService,
    private selfAttendanceService: SelfAttendanceService,
    public dtmService: DtmService,
    private sessionStorageService: SessionStorageService
  ) {

  }

  ngOnChanges(): void {
    this.expirationTime = this.expirationTime && this.expirationTime > 0 ? this.expirationTime : (new Date(this.pixData?.pixExpiryTime).getTime() - new Date().getTime()) / 1000;
  }

  invoiceSubtotal: number = 0;

  ngOnInit(): void {
    if (this.contract.trialData) {
      this.delayTest = moment(this.contract.trialData.trialEndDate, "DD/MM/YYYY").diff(moment(this.contract.saleDate, "DD/MM/YYYY"), 'days');
      this.installment = this.calculateInstallments();
      this.endDate = moment(this.contract.trialData.trialEndDate, "DD/MM/YYYY").subtract(1, 'days').format("DD/MM/YYYY");
    }

    this.classificationIdentifier = sessionStorage.getItem('classificationIdentifier');
    this.classificationName = sessionStorage.getItem('classificationName');
    this.expirationTime = this.expirationTime && this.expirationTime > 0 ? this.expirationTime : (new Date(this.pixData?.pixExpiryTime).getTime() - new Date().getTime()) / 1000;

    if (this.invoice && this.invoice.invoiceItem) {
      this.invoiceSubtotal = this.invoice.invoiceItem[0].value;
    }
  }

  formatErrorMessage(errorStatus: string): void {
    switch (errorStatus) {
      case 'PAYMENT_REJECTED':
        let businessId = this.contract.provisioningParameters.businessId;
        let userId = this.contract.provisioningParameters.userId;
        let url = environment.ecommerce_base_url + `/auto-atendimento/` + this.classificationIdentifier + `/alteracao-de-pagamento?businessId=` + businessId + `&userId=` + userId
        this.messageErrorItp = 'Desculpe, não foi possível concluir o pagamento via PIX devido à saldo suficiente na conta.<br><br>Você pode continuar a compra <b><a href="' + url + '">clicando aqui e selecionando uma outra forma de pagamento.</a></b>';


        this.dtmService.customErrorLoaded(["error"], {
          errorMessage: this.messageErrorItp
        });
        break;
      case 'CONSENT_REJECTED':
        this.messageErrorItp = 'Desculpe, o pagamento não pode ser concluído porque você não aceitou o termo de consentimento na etapa de pagamento do banco.';


        this.dtmService.customErrorLoaded(["error"], {
          errorMessage: this.messageErrorItp
        });
        break;
      default:
        this.messageErrorItp = 'Lamentamos, <b>ocorreu um problema no processamento do seu pagamento Pix.</b>';
        this.dtmService.customErrorLoaded(["error"], {
          errorMessage: this.messageErrorItp
        });
    }
  }

  changePage() {
    this.timeExpired = !this.timeExpired;
    if (this.timeExpired) {
      clearInterval(this.interval);
      this.clearDtm();
      this.dtmService.pageLoaded(Dtm.CodigoPagamentoExpirou, true, getDtm(Dtm.CodigoPagamentoExpirou, this.classificationIdentifier));
      this.dtmService.sendPageLoadEvent();
    }
  }

  pixPaid() {
    // GARANTE QUE QUALQUER INTERVALO ANTIGO SEJA LIMPO ANTES DE CRIAR UM NOVO
    if (this.interval) {
      clearInterval(this.interval);
    }
    this.interval = setInterval(() => this.consultRemittanceStatus(), this.pixData.remittanceConsultsInterval);
  }

  consultRemittanceStatus(): void {

    this.selfAttendanceService.getRemittanceStatus(this.pixData.txid).subscribe(
      (result) => {
        console.log('API Result:', result);
        if (result.remittance?.status) {
          this.sessionStorageService.clearSessionStorage(['isPixPaid']);
          this.dtmService.sendPixConfirmation();
          this.isPixPaid = true;
          this.sessionStorageService.setPixPaid(true);
          clearInterval(this.interval);
          this.clearDtm();
          this.dtmService.pageLoaded(Dtm.PagamentoReconhecido, true, getDtm(Dtm.PagamentoReconhecido, this.classificationIdentifier));
          this.dtmService.sendPageLoadEvent();
        } else {
          console.log('Pix ainda não pago, ou status não reconhecido.');
        }
      }
    );
  }

  clearDtm() {
    this.dtmService.customLoaded([]);
    this.dtmService.productsLoaded([{
      'classificationName': this.classificationName,
      'identifier': sessionStorage.getItem('product')
    }]);
  }

  getPix2ndCopy() {
    this.dtmService.pageLoaded(Dtm.NovoCodigoPix, true, getDtm(Dtm.NovoCodigoPix, this.classificationIdentifier));
    this.dtmService.customClickEvent("Gerar novo código");
    this.errors = [];
    this.submitting = true;
    this.selfAttendanceService.getPix2ndCopy(this.contract.provisioningParameters.businessId, this.contract.provisioningParameters.userId, this.contract.product.classificationIdentifier).subscribe(
      (selfAttendanceData) => {
        if (selfAttendanceData && selfAttendanceData.pixData) {
          selfAttendanceData.businessId = this.contract.provisioningParameters.businessId;
          selfAttendanceData.userId = this.contract.provisioningParameters.userId;

          this.pixData = selfAttendanceData.pixData;

          this.selfAttendanceService.setCurrentSelfAttendanceData(selfAttendanceData);
          this.expirationTime = (new Date(selfAttendanceData.pixData.pixExpiryTime).getTime() - new Date().getTime()) / 1000;
          this.submitting = false;
          this.changePage();
        }
      },
      (error) => {
        console.error(error);
        // this.errors = error;
        this.submitting = false;
        this.showCustomError("pix2ndCopyError", error);
      }
    )
  }

  calculateFinalValue() {
    let finalValue = this.contract.product.value;

    if (this.creditCardData && this.creditCardData.appliedCoupons) {
      this.creditCardData.appliedCoupons.forEach(discount => {
        if (discount.type === "EXTRA_BALANCE") {
          finalValue += discount.extraBalance;
        }
      });
    }

    if (this.pixData && this.pixData.appliedCoupons) {
      this.pixData.appliedCoupons.forEach(discount => {
        if (discount.type === "EXTRA_BALANCE") {
          finalValue += discount.extraBalance;
        }
      });
    }

    return finalValue;
  }

  formatDecimalValue(value: number) {
    return Number.isInteger(value) ? value : value.toFixed(2).replace(".", ",");
  }

  copyContent() {
    navigator.clipboard.writeText(this.bankBilletData.barcode);
    this.snackBarService.openSnackBar('Código copiado');
  }

  copyPixContent() {
    navigator.clipboard.writeText(this.pixData.qrCode);
    this.snackBarService.openSnackBar('Código copiado');
  }

  openBankBilletOnNewTab(url) {
    window.open(url, '_blank');
  }

  showCustomError(customErrorKey: string, integrationError?: any) {
    let integrationErrorMessage: any;

    switch (customErrorKey) {
      case "pix2ndCopyError":
        integrationErrorMessage = this.handleErrors(integrationError);
        this.errors = integrationErrorMessage.userMessage

        // Analytics
        // if (integrationErrorMessage.errorString || integrationErrorMessage.userMessage) {
        //   this.dtmService.customErrorLoaded(["error"], {
        //     errorDetail: integrationErrorMessage.errorString,
        //     errorMessage: integrationErrorMessage.userMessage,
        //   });
        // } else {
        //   // Erro de timeout na requisicao de venda
        //   this.dtmService.customErrorLoaded(["error"], {
        //     "errorDetail": "HttpErrorResponse",
        //     "errorMessage": "Erro de timeout durante a venda: " + integrationErrorMessage.message
        //   });
        // }
        break;
      default:
        break;
    }
    this.submitting = false;
  }

  handleErrors(error: any): any {
    const resultError: any = {};
    try {
      if (typeof error === "string") {
        error = JSON.parse(error);
      }

      if (error.status !== null && error.error) {
        resultError.status = error.status;
        resultError.endpoint = error.url && error.url.substring(error.url.indexOf("/api/1") + 6);
        resultError.name = error.name;

        resultError.handledError = !!error.error._messages.filter((message) => {
          return message.code !== null;
        });


        resultError.errors = error.error._messages.filter((message) => {
          return message.type === "ERROR";
        });

        resultError.warnings = error.error._messages.filter((message) => {
          return message.type === "WARNING";
        });

        let parseObj;
        try {

          parseObj = JSON.parse(resultError.errors[0].text);
        } catch (err) { }

        // console.log(JSON.parse(resultError.errors[0].text));
        if (parseObj && parseObj.context !== undefined) {
          resultError.context = parseObj.context;
          resultError.userMessage = parseObj.message;
          resultError.errorCode = resultError.errors[0].code || parseObj.code;
          resultError.errors[0].text = resultError.userMessage;

        } else {
          resultError.userMessage = resultError.errors[0].text;
          resultError.errorCode = resultError.errors[0].code;
        }

        resultError.errorString = `${resultError.context || "SYDLE"}:HTTP:${resultError.errorCode || resultError.status}:POST/${resultError.endpoint}:${JSON.stringify(resultError.errors.map(({ text }) => text))}:${JSON.stringify(resultError.warnings)}`;

        if (pix2ndCopyErrors[resultError.errorCode]) {
          resultError.userMessage = pix2ndCopyErrors[resultError.errorCode].contents;
        } else {
          resultError.userMessage = "Ocorreu um erro ao processar a solicitação, por favor tente novamente em alguns instantes.";
        }
      }
    }
    catch (e) {
      resultError.errorString = JSON.stringify(error);
      resultError.userMessage = "Ocorreu um erro ao processar a sua solicitação, tente novamente em alguns instantes.";
    }

    return resultError;
  }

  automaticRechargeValueFormat() {
    let automaticRechargeValue = this.contract.product.automaticRecharge;
    return Number.isInteger(automaticRechargeValue) ? automaticRechargeValue : automaticRechargeValue.toFixed(2).replace('.', ',');
  }

  calculateInstallments() {
    let paymentConditionIdentifier = this.contract.paymentMethod.paymentConditionIdentifier;
    let numberInstallments = paymentConditionIdentifier.match(/\d/g).join("");
    return parseInt(numberInstallments);
  }

  calculeInstallmentValue() {
    let installmentValue = this.contract.product.value / this.installment;
    return installmentValue.toFixed(2).replace('.', ',');
  }
}
